// Widget Scripts
import cards from './js/widgets/cards.js';
import mainFeatureSlide from './js/widgets/mainFeatureSlide.js';
import faircards from './js/widgets/faircards.js';
import seoBackground from './js/widgets/seoBackground.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';
import seo from './js/widgets/seo.js';
import sponsorWidgetContainer from './js/widgets/cssSponsors.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import mutischeduleBackground from './js/widgets/mutischeduleBackground.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    // cardWidget();  
    mainFeatureSlide(); 
    faircards();
    seoBackground();
    mutischeduleBackground();
    seo();
    cards();
    multiScheduleFeature();
    sponsorWidgetContainer();
  });
  $(window).load(function () {
    socialNetworkWidget.facebookfeed(true);        
  })
}
$(document).ready(function() {
$('.header').clone().appendTo('.mobile-menu-header');

});